import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "w-full max-w-xl p-8 flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-start space-x-4" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "text-xl font-semibold text-gray-900 self-center" }
const _hoisted_5 = { class: "mt-4 text-base font-regular leading-normal text-gray-600" }
const _hoisted_6 = {
  key: 0,
  class: "mt-8 w-full justify-start flex flex-col space-y-4"
}
const _hoisted_7 = { class: "mt-8 flex flex-end justify-end space-x-4" }

import { computed, onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { BaseButton } from '@/lib/components/Button';
import { BaseSelect } from '@/lib/components/Select';
import { BaseIcon } from '@/lib/components/Icon';
import axios, { CancelTokenSource } from 'axios';
import { CopdAssignableOrganisationService, CopdProgramService } from '@/services/api';
import { IOption, IValidationError } from '@/lib';
import { Organisation } from '@/models';
import { useNotificationStore } from '@/stores/notification.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AssignToOrgModal',
  props: {
  programId: {
    type: String,
    required: true
  }
},
  emits: ["close", "record-event", "update-assigned-org"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
  (e: 'record-event', event: string): void;
  (e: 'update-assigned-org', organisation: Organisation): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const { t } = useI18n();



const organisationalUnitIdToAssign = ref<string | null>(null);
const request = ref<CancelTokenSource | null>(null);
const errors = ref<IValidationError>({
  errors: {},
  message: ''
});
const assignableOrganisations = ref<Organisation[]>([]);
const assignableOrganisationService = new CopdAssignableOrganisationService();
const copdProgramService = new CopdProgramService();
const notificationStore = useNotificationStore();

const organisationOptions = computed<Array<IOption>>(() => assignableOrganisations.value.map((organisation) => ({
  value: organisation.id,
  label: organisation.name
})));

onBeforeMount(() => {
  fetchAssignableOrganisations();
  emit('record-event', 'started assigning patient to organisation');
});
const fetchAssignableOrganisations = async () => {
  try {
    const response = await assignableOrganisationService.index();
    assignableOrganisations.value = response.data;
  } catch (e) {
    await notificationStore.addErrorNotification({
      title: t('custom.uhb.copd.error-fetching-assignable-organisations')
    });
  }
};
const assignToOrganisation = async () => {
  if (organisationalUnitIdToAssign.value === null) {
    return;
  }

  try {
    request.value = axios.CancelToken.source();
    await copdProgramService.update(
      props.programId,
      { assigned_organisational_unit_id: organisationalUnitIdToAssign.value },
      { cancelToken: request.value.token }
    );

    const assignedOrg =
      assignableOrganisations.value.find((organisation) => organisation.id === organisationalUnitIdToAssign.value) ??
      null;

    emit('update-assigned-org', assignedOrg);
    emit('record-event', 'completed assigning patient to organisation');
    emit('close');
    organisationalUnitIdToAssign.value = null;
  } catch (e) {
    errors.value = e.response.data;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(BaseIcon), {
          name: "crossroad",
          stroke: false,
          height: "2rem"
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('custom.uhb.copd.assign-to-org')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('custom.uhb.copd.assign-to-org-desc')), 1),
    (_unref(organisationOptions).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(BaseSelect), {
            modelValue: organisationalUnitIdToAssign.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organisationalUnitIdToAssign).value = $event)),
            error: errors.value?.errors?.assigned_organisational_unit_id?.[0],
            label: _ctx.$t('custom.uhb.copd.assign-to-org'),
            options: _unref(organisationOptions),
            placeholder: _ctx.$t('custom.uhb.copd.select-org'),
            "data-dusk": "assign-to-organisation-options"
          }, null, 8, ["modelValue", "error", "label", "options", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(BaseButton), {
        size: "large",
        color: "ghost",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('platform.common.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        size: "large",
        color: "primary",
        disabled: !organisationalUnitIdToAssign.value,
        "data-dusk": "assign-to-organisation-update",
        onClick: _withModifiers(assignToOrganisation, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('platform.common.update')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}
}

})